import React from "react";
import { connect } from "react-redux";
import { hasAnyRole } from "./authUtils";

import Unauthorized from "auth/Unauthorized";

const mapStateToProps = state => ({
  user: state.auth.user,
  currentOrganization: state.auth.currentOrganization,
});

const withAuthorization = (Component, showUnauthorized = true) => {
  const wrappedComponent = class extends React.Component {
    render() {
      const { roles, user, currentOrganization, ...otherProps } = this.props;

      if (this.checkAuthorization({ roles, user, currentOrganization })) {
        return <Component {...otherProps} />;
      } else if (showUnauthorized) {
        return (
          <Unauthorized message="You are not authorized to access this resource." />
        );
      } else {
        return null;
      }
    }

    checkAuthorization(props) {
      const { roles, user, currentOrganization } = props;
      return hasAnyRole(user, roles) || hasAnyRole(currentOrganization, roles);
    }
  };

  return connect(mapStateToProps)(wrappedComponent);
};

export default withAuthorization;
